import React from 'react';
import { Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';
import DesignServicesRoundedIcon from '@mui/icons-material/DesignServicesRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import CopyrightRoundedIcon from '@mui/icons-material/CopyrightRounded';
import ShieldRoundedIcon from '@mui/icons-material/ShieldRounded';
import PrivacyTipRoundedIcon from '@mui/icons-material/PrivacyTipRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import LegalPage from './components/LegalPage';

const Text = ({ children }) => (
  <Typography variant="body2" component="p" sx={{ color: 'inherit', fontSize: 'inherit', lineHeight: 'inherit' }}>
    {children}
  </Typography>
);

export default function TermsAndConditions() {
  const sections = [
    {
      icon: <WavingHandRoundedIcon />,
      title: 'Introduction',
      content: (
        <Text>
          Welcome to FalconXcellence! These Terms and Conditions govern your use of our website and
          services. By accessing or using our services, you agree to be bound by these terms.
        </Text>
      ),
    },
    {
      icon: <DesignServicesRoundedIcon />,
      title: 'Services Provided',
      content: (
        <Text>
          FalconXcellence provides software consulting services, including but not limited to
          full-stack development, mobile applications, cloud computing, and distributed systems. We
          aim to deliver high-quality solutions tailored to your business needs.
        </Text>
      ),
    },
    {
      icon: <VerifiedUserRoundedIcon />,
      title: 'Responsible Usage',
      content: (
        <Text>
          Users are expected to use our services in a lawful and ethical manner. Any misuse of our
          platform, including but not limited to attempting to disrupt services or engaging in
          fraudulent activity, may result in restricted access.
        </Text>
      ),
    },
    {
      icon: <CopyrightRoundedIcon />,
      title: 'Intellectual Property',
      content: (
        <Text>
          All content, trademarks, and intellectual property displayed on our website are the
          property of FalconXcellence unless otherwise stated. Unauthorized reproduction or
          distribution is prohibited.
        </Text>
      ),
    },
    {
      icon: <ShieldRoundedIcon />,
      title: 'Limitation of Liability',
      content: (
        <Text>
          While we strive to provide accurate and reliable information, FalconXcellence is not
          responsible for any damages resulting from the use of our services or reliance on
          information provided on this website.
        </Text>
      ),
    },
    {
      icon: <PrivacyTipRoundedIcon />,
      title: 'Privacy Policy',
      content: (
        <span>
          Your privacy is important to us. Please review our{' '}
          <Link component={RouterLink} to="/privacy">
            Privacy Policy
          </Link>{' '}
          to understand how we collect, use, and protect your data.
        </span>
      ),
    },
    {
      icon: <UpdateRoundedIcon />,
      title: 'Changes to These Terms',
      content: (
        <Text>
          We reserve the right to modify these Terms and Conditions at any time. Changes will be
          effective upon posting, and continued use of our services implies acceptance of the
          updated terms.
        </Text>
      ),
    },
  ];

  return (
    <LegalPage
      icon={<GavelRoundedIcon />}
      eyebrow="Legal"
      title="Terms &"
      highlight="Conditions"
      intro="The ground rules for using the FalconXcellence website and services. By accessing our services, you agree to the terms outlined below."
      lastUpdated="July 7, 2026"
      sections={sections}
      contact={{
        title: 'Questions about these terms?',
        content: (
          <span>
            If you have any questions or concerns about these Terms and Conditions, reach us any time
            at{' '}
            <Link component="a" href="mailto:info@falconxcellence.com">
              info@falconxcellence.com
            </Link>
            .
          </span>
        ),
      }}
    />
  );
}
